<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：重置、修改管理员密码
    -->
    <div class="bg_add">
		<div class="changead">
			<div class="changeadinput">
				<el-form :label-position="labelPosition" label-width="100px" :model="changepassword">
					<el-form-item label="新密码">
						<el-input v-model="changepassword.newpassword"  placeholder="请输入新密码" :type="change" style="width:220px;"></el-input>
					</el-form-item>
					<el-form-item label="确认新密码">
						<el-input v-model="changepassword.turePassword"  placeholder="请确认新密码" :type="change" style="width:220px;"></el-input>
					</el-form-item>
					 <el-button type="primary" @click='sumbit()'>提交</el-button>
					 <el-button @click="pageback">取消</el-button>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'change-adpw',
		props:['adpw'],
		data(){
			return {
				labelPosition: 'left',
				change:"password",
				changepassword: {
					oldpassword: '',
					newpassword: '',
					turePassword: ''
				},
			}
		},
		methods:{
			pageback(){
				this.$emit('changepwfalse')
			},
			sumbit(){
				let newpassword = this.changepassword.newpassword
				let turepassword = this.changepassword.turePassword
				if(newpassword == 0){
					return this.$message.warning("请输入新密码")
				}
				if(turepassword == 0){
					return this.$message.warning("请确认新密码")
				}
				if(newpassword.length < 6){
					return this.$message.warning("新密码不得小于6位")
				}
				if(newpassword.length > 12){
					return this.$message.warning("新密码不得超过12位")
				}
				if(newpassword != turepassword){
					this.changepassword.turePassword = ''
					return this.$message.warning("两次密码不一致")	
				}
				this.$jssdk.admin.editPassword({admin_id:this.adpw.admin_id,password:this.changepassword.newpassword},(data)=>{
					this.$message({
						type:'success',
						message:'修改成功',
						duration:1000,
					})
					this.pageback()
					console.log(data)
					return
				})
			},
		},
	}
</script>

<style scoped>
	.bg_add{
		background-color: rgba(0,0,0,.7);
		width: 100%;
		height: 965px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 6;
	}
	.changead{
		background-color: white;
		width:450px;
		position: absolute;
		left: 740px;
		top: 340px;
		color: white;
		z-index: 3;
		overflow: hidden;
		padding: 15px;
		border-radius: 15px;
		border:1px solid #ccc;
		box-shadow: 2px 2px 2px #000;
	}
	.changeadinput{
		width: 370px;
		color: red;
		margin: 0 auto;
		text-align: center;
		padding: 20px 0;
	}
	@media only screen and (max-width:1400px ) {
		.changead{
			background-color: white;
			width:450px;
			position: absolute;
			left: 440px;
			top: 140px;
			color: white;
			z-index: 3;
			overflow: hidden;
			padding: 15px;
			border-radius: 15px;
			border:1px solid #ccc;
			box-shadow: 2px 2px 2px #000;
		}
	}
</style>


// WEBPACK FOOTER //
// changeAdPw.vue?6c143735